import React from 'react';
import { MinusIcon, PlusIcon } from 'lucide-react';
interface OrderSummaryProps {
  selectedPackage: string;
  setSelectedPackage: (packageName: string) => void;
  quantity: number;
  setQuantity: (quantity: number) => void;
  subtotal: number;
}
export function OrderSummary({
  selectedPackage,
  setSelectedPackage,
  quantity,
  setQuantity,
  subtotal
}: OrderSummaryProps) {
  const packages = [{
    id: 'starter',
    name: 'Starter Pack',
    description: '1 month supply'
  }, {
    id: 'performance',
    name: 'Performance Pack',
    description: '3 month supply'
  }, {
    id: 'executive',
    name: 'Executive Pack',
    description: '6 month supply'
  }];
  const decreaseQuantity = () => {
    if (quantity > 1) {
      setQuantity(quantity - 1);
    }
  };
  const increaseQuantity = () => {
    setQuantity(quantity + 1);
  };
  return <div className="bg-white rounded-lg shadow-lg p-6" data-id="element-95">
      <h2 className="text-xl font-semibold mb-4" data-id="element-96">Order Summary</h2>
      <div className="flex items-center mb-6" data-id="element-97">
        <div className="w-24 h-24 bg-gray-200 rounded-md flex items-center justify-center mr-4" data-id="element-98">
          <img src="https://images.unsplash.com/photo-1584308666744-24d5c474f2ae?ixlib=rb-1.2.1&auto=format&fit=crop&w=150&q=80" alt="NightPhase Sleep Patch package" className="max-w-full max-h-full object-cover rounded-md" data-id="element-99" />
        </div>
        <div data-id="element-100">
          <h3 className="font-medium" data-id="element-101">NightPhase Sleep Patch</h3>
          <p className="text-gray-600 text-sm" data-id="element-102">Natural sleep aid</p>
        </div>
      </div>
      <div className="mb-6" data-id="element-103">
        <h3 className="font-medium mb-2" data-id="element-104">Select Package</h3>
        <div className="space-y-2" data-id="element-105">
          {packages.map(pkg => <label key={pkg.id} className={`flex items-center p-3 border rounded-md cursor-pointer transition-colors ${selectedPackage === pkg.id ? 'border-indigo-500 bg-indigo-50' : 'border-gray-200 hover:bg-gray-50'}`} data-id="element-106">
              <input type="radio" name="package" value={pkg.id} checked={selectedPackage === pkg.id} onChange={() => setSelectedPackage(pkg.id)} className="h-4 w-4 text-indigo-600 border-gray-300 focus:ring-indigo-500" data-id="element-107" />
              <div className="ml-3" data-id="element-108">
                <span className="block font-medium" data-id="element-109">{pkg.name}</span>
                <span className="block text-sm text-gray-500" data-id="element-110">
                  {pkg.description}
                </span>
              </div>
            </label>)}
        </div>
      </div>
      <div className="mb-6" data-id="element-111">
        <h3 className="font-medium mb-2" data-id="element-112">Quantity</h3>
        <div className="flex items-center" data-id="element-113">
          <button onClick={decreaseQuantity} className="w-8 h-8 flex items-center justify-center border border-gray-300 rounded-l-md bg-gray-50" aria-label="Decrease quantity" data-id="element-114">
            <MinusIcon className="h-4 w-4" data-id="element-115" />
          </button>
          <div className="w-12 h-8 flex items-center justify-center border-t border-b border-gray-300 bg-white" data-id="element-116">
            {quantity}
          </div>
          <button onClick={increaseQuantity} className="w-8 h-8 flex items-center justify-center border border-gray-300 rounded-r-md bg-gray-50" aria-label="Increase quantity" data-id="element-117">
            <PlusIcon className="h-4 w-4" data-id="element-118" />
          </button>
        </div>
      </div>
      <div className="border-t pt-4" data-id="element-119">
        <div className="flex justify-between items-center" data-id="element-120">
          <span className="font-medium" data-id="element-121">Subtotal</span>
          <span className="font-medium" data-id="element-122">€{subtotal.toFixed(2)}</span>
        </div>
      </div>
    </div>;
}